import { I18n } from "../services/I18n";
import "./generated/site-translations-en-GB";
import common_enGB from "../../../../../libs/ps/restaumatic-common/locales/en-GB.json";
import core_types_sites_enGB from "../../../../../libs/ps/restaumatic-core-types-sites/locales/en-GB.json";
import common_en from "../../../../../libs/ps/restaumatic-common/locales/en.json";
import core_types_sites_en from "../../../../../libs/ps/restaumatic-core-types-sites/locales/en.json";
I18n.translations = I18n.translations || {};
I18n.translations = I18n.extend(I18n.translations, {
  "en-GB": { _core_types_sites: core_types_sites_enGB },
});
I18n.translations = I18n.extend(I18n.translations, {
  "en-GB": { _common: common_enGB },
});
I18n.translations = I18n.extend(I18n.translations, {
  en: { _core_types_sites: core_types_sites_en },
});
I18n.translations = I18n.extend(I18n.translations, {
  en: { _common: common_en },
});
